/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word Frequency Counter — Most Used Words | Toolverse`)
};

const es_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Frecuencia de Palabras — Palabras Más Usadas | Toolverse`)
};

const de_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wortfrequenzzähler — Meistgenutzte Wörter | Toolverse`)
};

const nl_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Woordfrequentieteller — Meest gebruikte woorden | Toolverse`)
};

const fr_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compteur de fréquence des mots — Mots les plus utilisés | Toolverse`)
};

const it_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatore di frequenza delle parole — Parole più utilizzate | Toolverse`)
};

const pt_br2_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Frequência de Palavras — Palavras Mais Usadas | Toolverse`)
};

const pt_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contador de Frequência de Palavras — Palavras Mais Utilizadas | Toolverse`)
};

const ja_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語頻度カウンター — 最も使用された単語 | Toolverse`)
};

const zh_wf_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`词频统计工具 — 最常用单词 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wf_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wf_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wf_meta_title", locale)
	if (locale === "en") return en_wf_meta_title(inputs)
	if (locale === "es") return es_wf_meta_title(inputs)
	if (locale === "de") return de_wf_meta_title(inputs)
	if (locale === "nl") return nl_wf_meta_title(inputs)
	if (locale === "fr") return fr_wf_meta_title(inputs)
	if (locale === "it") return it_wf_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_wf_meta_title(inputs)
	if (locale === "pt") return pt_wf_meta_title(inputs)
	if (locale === "ja") return ja_wf_meta_title(inputs)
	return zh_wf_meta_title(inputs)
};